var site = site || {};

site.quickshop = site.quickshop || {};
(function ($) {
  Drupal.behaviors.pcgProductMobileV1 = {
    attach: function (context, settings) {
      $('.pcg-product-mobile-v1').each(function () {
        var thisFormatter = $(this);
        // Check if the reviews img is tranparent.gif and add hidden class to .reviews parent class
        var reviews = thisFormatter.find('.reviews'),
          reviewsImg = reviews.find('img');

        if (reviewsImg.attr('src') == '/media/export/images/global/transparent.gif') {
          reviews.addClass('hidden');
        }

        // For CTA button loading...
        thisFormatter.find('.button.cta').addClass('mobile');
      });

      // Add CTA button loading...
      $('.button.cta.mobile', context).not('.action-spp, .action-quickview').on('click', function(e) {
        e.preventDefault();

        var loadingId = site.loading.show({
          'target': e.target,
          'matchTarget': ['display', 'height', 'width'],
          'css': {
            'text-align': 'center',
            'vertical-align': 'top'
          }
        });

        $(document).one('addToCart.success addToCart.failure', function () {
          site.loading.hide(loadingId);
        });
      });
      // Open Sells with panel
      $('.js-select_kit_component', context).once('select_kit_component').on('click', function () {
        var $this = $(this);
        var $productWrapper = $this.closest('.js-product');
        var $sellsWithPanel = $productWrapper.find('.js-sells-with--panel');
        var $addToBag = $();

        if ($sellsWithPanel.hasClass('hidden')) {
          $sellsWithPanel.removeClass('hidden');
          $sellsWithPanel.find('caret').removeClass('hidden');
          if (!$sellsWithPanel.hasClass('sells-with-loaded')) {
            $addToBag = $sellsWithPanel.find('.js-add-to-cart');
            $sellsWithPanel.addClass('sells-with-loaded');
            $(document).trigger('sells_with_init', $sellsWithPanel);
            site.quickshop.initAddToBag($addToBag, $productWrapper.data('skubaseid'));
          } else {
            $(document).trigger('sells_with_reinit', $sellsWithPanel);
          }
        } else {
          $sellsWithPanel.addClass('hidden');
          $sellsWithPanel.find('caret').addClass('hidden');
        }
      });
    }
  };
})(jQuery);
